import { render, staticRenderFns } from "./CustomerStatements.vue?vue&type=template&id=6ab95dc8&scoped=true"
import script from "./CustomerStatements.vue?vue&type=script&lang=js"
export * from "./CustomerStatements.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatements.vue?vue&type=style&index=0&id=6ab95dc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab95dc8",
  null
  
)

export default component.exports